// Copyright 2020 Sorama B.V.

import { PLATFORM } from "aurelia-framework";
import {
    IWorkflowModuleConfig,
    WorkflowModuleType,
} from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";

export class PresentationWorkflowModuleCatalog {
    static CanvasAddModule: IWorkflowModuleConfig = {
        name: "canvasadd",
        modulePath: PLATFORM.moduleName("modules/workflows/Presentation/CanvasAdd/CanvasAddModule"),
        title: "Add",
        moduleType: WorkflowModuleType.Presentation,
        requireClient: false,
        requireSignIn: true,
    };

    static presentationPageModule: IWorkflowModuleConfig = {
        name: "presentationpage",
        modulePath: PLATFORM.moduleName("modules/workflows/Presentation/PresentationPage/PresentationPageModule"),
        title: "Presentation",
        moduleType: WorkflowModuleType.Presentation,
        requireClient: false,
        requireSignIn: true,
        canExtend: false,
        isDefaultExtended: true,
        isInadmissible: true,
    };
}
